import React from 'react'
import Telephone from 'custom/assets/contact-us/telephone.svg'
import Clock from 'custom/assets/contact-us/clock.svg'
import Web1 from 'custom/assets/contact-us/web1.svg'
import Web2 from 'custom/assets/contact-us/web2.svg'
import Address from 'custom/assets/contact-us/address.svg'
import LinkedInLogo from 'custom/assets/contact-us/linkedin'
import FacebookLogo from 'custom/assets/contact-us/facebook'
import InstagramLogo from 'custom/assets/contact-us/instagram.jsx'
import { Link } from 'react-router-dom'

import contactInfo from 'custom/static/contactUs.json'

export default function ContactUsContent() {
  return (
    <div id='ContactUs'>
      <div>
        <div>
          <div className='row mb-3' style={{ justifyContent: 'center' }}>
            <img src={Address} alt='' height='20' width='20' />
          </div>
          <div className='row'>
            <h5 className='font-weight-bold col-12 text-center' style={{ fontSize: '14px' }}>
              {contactInfo['headOffice']}
            </h5>
          </div>
        </div>
        <div>
          <div className='row mb-3' style={{ justifyContent: 'center' }}>
            <img src={Telephone} alt='' height='20' width='20' />
          </div>
          <div className='row'>
            <h5 className='font-weight-bold col-12 text-center' style={{ fontSize: '14px' }}>
              {contactInfo['tel']}
            </h5>
          </div>
          {/* <div>
            <div className='row mb-3' style={{ justifyContent: 'center' }}>
              <img src={Web1} alt='' height='55' width='55' />
            </div>
            <div className='row'>
              <h5 className='font-weight-bold col-12 text-center' style={{ fontSize: '14px' }}>
                {contactInfo['website']}
              </h5>
            </div>
          </div> */}
          <div>
            <div className='row mb-3' style={{ justifyContent: 'center' }}>
              <img src={Web2} alt='' height='20' width='20' />
            </div>
            <div className='row'>
              <Link
                onClick={() => window.open(contactInfo['website'], '_blank')}
                className='col-12 text-center'>
                <h5 className='font-weight-bold' style={{ fontSize: '14px' }}>
                  {contactInfo['website']}
                </h5>
              </Link>
            </div>
          </div>
        </div>
        <div>
          <div className='row mb-3' style={{ justifyContent: 'center' }}>
            <img src={Clock} alt='' height='20' width='20' />
          </div>
          <div className='row'>
            <h5 className='font-weight-bold col-12  text-center' style={{ fontSize: '14px' }}>
              {contactInfo['workingHours']}
            </h5>
          </div>
          <div className='row mt-4 justify-content-center'>
            <div className='d-flex justify-content-space-between '>
              <div className='px-2'>
                <Link
                  style={
                    contactInfo['facebook'].length > 0
                      ? { pointerEvents: 'auto' }
                      : { pointerEvents: 'none' }
                  }
                  onClick={() => window.open(contactInfo['facebook'], '_blank')}>
                  <FacebookLogo height='24' width='24' />
                </Link>
              </div>
              <div className='px-2'>
                <Link
                  style={
                    contactInfo['linkedIn'].length > 0
                      ? { pointerEvents: 'auto' }
                      : { pointerEvents: 'none' }
                  }
                  onClick={() => window.open(contactInfo['linkedIn'], '_blank')}>
                  <LinkedInLogo height='24' width='24' />
                </Link>
              </div>
              <div className='px-2'>
                <Link
                  style={
                    contactInfo['youTube'].length > 0
                      ? { pointerEvents: 'auto' }
                      : { pointerEvents: 'none' }
                  }
                  onClick={() => window.open(contactInfo['youTube'], '_blank')}>
                  <InstagramLogo height='24' width='24' />
                </Link>
              </div>
            </div>
            <h5 className='font-weight-bold mt-4 mb-4 col-12 text-center'>Follow On</h5>
          </div>
        </div>
      </div>
    </div>
  )
}
